import { MuiF } from '../../../../Mui/F/Function/module/MuiF.js';
import { NessLabsNessModalMuiF } from '../Mui/module/NessLabsNessModalMuiF.js';
import { NessUtilF } from '../../../../Ness/Util/F/Function/module/NessUtilF.js';

const preloadImagesFromHtml = async (root_el) => {
  const images = root_el.querySelectorAll('img[src]');
  const preload_promises = Array.from(images).map(async (img) => {
    const image = new Image();
    image.src = img.src;
    try {
      await image.decode();
    } catch {
      // 이미지 디코드 실패 시 무시
    }
  });

  await Promise.all(preload_promises);
};

/**
 * Ness 모달을 열어주는 함수
 * @param {Object} options - 모달 옵션
 * @param {Object} options.data - 모달에 표시될 데이터 (title, body, footer, buttons)
 * @param {string} options.data.body - 모달 바디 HTML (필수)
 * @param {string} options.data.footer - 모달 푸터 HTML (선택사항, buttons 대신 사용)
 * @param {Array} options.data.buttons - 버튼 배열 (선택사항)
 * @param {string} options.data.buttons[].label - 버튼 레이블
 * @param {string} options.data.buttons[].type - 버튼 타입 (confirm, cancel)
 * @param {string} options.data.buttons[].class - 버튼 클래스
 * @param {Object} options.frameOptions - 프레임 옵션 커스터마이징
 * @param {boolean} options.frameOptions.is_modal - 모달로 열지 여부 (기본: PC는 true, 모바일은 false)
 * @param {boolean} options.frameOptions.always_remove - 닫을 때 항상 삭제 (기본: true)
 * @param {boolean} options.frameOptions.animation - 애니메이션 여부 (기본: true)
 * @param {Object} options.tabOptions - 탭 옵션 커스터마이징
 * @param {Function} options.tabOptions.appended - 탭이 추가된 후 실행될 콜백
 * @param {Function} options.tabOptions.showed - 탭이 보여진 후 실행될 콜백
 * @returns {Promise<boolean|undefined>} confirm 버튼 클릭 시 true, 그 외 닫힘 시 undefined
 */
export const openNessModal = async (options = {}) => {
  const { data = {}, frameOptions = {}, tabOptions = {} } = options;
  const is_mobile = NessUtilF.isMobile();

  return new Promise((resolve) => {
    MuiF.openFrame(NessLabsNessModalMuiF.frame, (frame, page, [tab]) => {
      frame.hide_frame_button_type = '';
      frame.always_remove = frameOptions.always_remove ?? true;
      frame.animation = frameOptions.animation ?? true;
      frame.is_modal = frameOptions.is_modal ?? !is_mobile;

      frame.closed = (_frame, closed_data) => !closed_data && resolve();

      tab.makeData = () => data;
      tab.appending = async (tab_el) => {
        await preloadImagesFromHtml(tab_el);
      };
      tab.appended = (tab_el) => {
        if (tabOptions.appended) {
          tabOptions.appended(tab_el);
        }

        if (data.buttons?.length > 0) {
          const buttons = tab_el.querySelectorAll('.ness-modal__button');
          buttons.forEach((button, index) => {
            button.addEventListener('click', async () => {
              const button_data = data.buttons[index];
              if (button_data.type === 'cancel' || button_data.close === true) {
                await MuiF.removeFrame();
              }
              if (button_data.type === 'confirm') {
                await MuiF.removeFrame(true);
                resolve(true);
              }
            });
          });
        }
      };

      if (tabOptions.showed) {
        tab.showed = tabOptions.showed;
      }
    });
  });
};
